import React, { useEffect } from "react";
import Privacy from "../components/privacy-policy/Privacy";
import CommonHero from "../components/common/CommonHero";
import PrivacyPolicyImage from "../../src/assets/img/privacy-policy-bg.webp";

const PrivacyPage = () => {
  useEffect(() => {
    document.getElementById("title-page").innerHTML = "TripNest | Privacy policy";
  }, []);
  return (
    <div>
      <CommonHero imgUrl={PrivacyPolicyImage} text="Privacy Policy" />
      <Privacy />
    </div>
  );
};

export default PrivacyPage;
